module.exports = __webpack_public_path__ + "img/img-member.d6a761a4.png";